import { Button, Typography } from "@mui/material";
import { typeColorMap } from "../consts";
import { Suggestion } from "../types";

type SuggestionCardProps = {
  suggestion: Suggestion;
  handleSuggestionClick: (suggestion: Suggestion) => void;
};

export const SuggestionCard = ({
  suggestion,
  handleSuggestionClick,
}: SuggestionCardProps) => {
  return (
    <Button
      variant="outlined"
      sx={{
        padding: "5px 15px",
        borderRadius: "20px",
        textTransform: "none",
        minWidth: "fit-content",
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        borderColor: typeColorMap[suggestion.type] || "default",
        color: typeColorMap[suggestion.type] || "default",
      }}
      onClick={() => handleSuggestionClick(suggestion)}
    >
      {suggestion.tag && (
        <Typography variant="caption">
          <b>{suggestion.tag}</b>
        </Typography>
      )}
      <Typography variant="body2">{suggestion.fe_display}</Typography>
    </Button>
  );
};
